import { useSetRecoilState } from "recoil";
import { authAtom } from "../../recoil/atoms";
import { useQuery } from "react-query";
import { listMyTickets } from "../../api/ticketApi";

export const useMyTickets = () => {
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({ response: { status } }) => {
    if (status === 401) {
      // 인증에 실패한 경우는 로그아웃시키고 재로그인하도록 해야한다.
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };
  return useQuery("myTickets", () => listMyTickets(), {
    select: (data) => data.data,
    onError,
  });
};
